const BRANDING_LOGO = '/api/client/branding/logo';
const BRANDING_FAVICON = '/api/client/branding/favicon';

const isStoredBrandingAsset = (value) => {
  if (!value || typeof value !== 'string') return false;
  const raw = value.trim();
  if (!raw || raw.startsWith('data:')) return Boolean(raw);
  return true;
};

export const resolveClientLogoDisplayUrl = (logo) => {
  if (!isStoredBrandingAsset(logo)) return null;
  const raw = logo.trim();
  if (raw.startsWith('data:')) return raw;
  if (raw.startsWith(BRANDING_LOGO)) return raw;
  if (raw.includes('amazonaws.com') || raw.startsWith('s3://') || /^https?:\/\//i.test(raw)) {
    return BRANDING_LOGO;
  }
  return BRANDING_LOGO;
};

export const resolveClientFaviconDisplayUrl = (favicon) => {
  if (!isStoredBrandingAsset(favicon)) return null;
  const raw = favicon.trim();
  if (raw.startsWith('data:')) return raw;
  if (raw.startsWith(BRANDING_FAVICON)) return raw;
  if (raw.includes('amazonaws.com') || raw.startsWith('s3://') || /^https?:\/\//i.test(raw)) {
    return BRANDING_FAVICON;
  }
  return BRANDING_FAVICON;
};

export const normalizeClientMetaBranding = (client) => {
  if (!client || typeof client !== 'object') return client;
  const next = { ...client };
  if (isStoredBrandingAsset(next.logo)) {
    next.logo = resolveClientLogoDisplayUrl(next.logo);
  }
  if (isStoredBrandingAsset(next.favicon)) {
    next.favicon = resolveClientFaviconDisplayUrl(next.favicon);
  }
  return next;
};

const removeCompetingFaviconLinks = () => {
  document.querySelectorAll('link[rel~="icon"]').forEach((link) => {
    if (link.id === 'app-favicon') return;
    const href = (link.getAttribute('href') || '').trim();
    if (href.endsWith('logo512.png') || href.endsWith('favicon.ico')) {
      link.remove();
    }
  });
};

export const applyClientFavicon = (favicon) => {
  const el = document.getElementById('app-favicon');
  if (!el) return;

  const href = resolveClientFaviconDisplayUrl(favicon);
  if (href) {
    el.href = href;
    if (href.startsWith('data:')) {
      const semi = href.indexOf(';');
      if (semi > 5) el.type = href.slice(5, semi);
    } else {
      el.removeAttribute('type');
    }
    removeCompetingFaviconLinks();
    return;
  }

  el.href = '/static/favicon.ico';
  el.removeAttribute('type');
};
